import firebase from "firebase/compat/app";
import "firebase/compat/database";


import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBwYyN9LpXtd2F7-NKRocZXX5vv1R1gGgs",
  authDomain: "ticket-api-a6731.firebaseapp.com",
  databaseURL: "https://ticket-api-a6731-default-rtdb.firebaseio.com",
  projectId: "ticket-api-a6731",
  storageBucket: "ticket-api-a6731.appspot.com",
  messagingSenderId: "984320568959",
  appId: "1:984320568959:web:342b04cbfd5db94bf6594a",
  measurementId: "G-N6MLBLKBFM",
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
getAnalytics(app);

export default firebase;
